import React, { FC } from 'react'

import { Icon5gConnectivityProps } from './Icon5gConnectivity.types'
import * as Styled from './styles/Icon5gConnectivity.style'

import { nonThemeableRules } from '../../ruleSet'

const Icon5gConnectivity: FC<Icon5gConnectivityProps> = ({
  size = nonThemeableRules.defaultSize as number as Icon5gConnectivityProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: Icon5gConnectivityProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <ellipse cx='32' cy='107.96' rx='16' ry='16.04' />
        <ellipse cx='80' cy='99.96' rx='16' ry='16.04' />
        <ellipse cx='128' cy='107.96' rx='16' ry='16.04' />
        <path d='M60 156c-3.48-21.12-15-32-27.83-32S7.48 134.88 4 156' />
        <path d='M156 156c-3.48-21.12-15-32-27.83-32s-24.69 10.88-28.17 32' />
        <path d='M105.77 138.73C100.83 123.7 91 116 80.17 116s-20.87 7.68-25.89 22.66M105.22 4a3.94 3.94 0 0 0-3.92-4 3.89 3.89 0 0 0-2.84 1.19 26.12 26.12 0 0 1-36.89 0A3.94 3.94 0 0 0 56 6.76a34 34 0 0 0 48.08 0A3.87 3.87 0 0 0 105.22 4z' />
        <path d='M40.82 18.5a4 4 0 0 0 0 5.58 55.46 55.46 0 0 0 78.35.1l.1-.1a3.8 3.8 0 0 0 1.14-2.72 3.95 3.95 0 0 0-6.8-2.77 47.57 47.57 0 0 1-67.21-.09 3.94 3.94 0 0 0-5.57 0z' />
        <path d='M80 56.13a68.55 68.55 0 0 1-48.79-20.27 3.94 3.94 0 1 0-5.71 5.44l.14.14a76.87 76.87 0 0 0 108.7.11l.13-.13a3.9 3.9 0 0 0 1.12-2.7 4 4 0 0 0-3.91-4A4 4 0 0 0 128.8 36 68.51 68.51 0 0 1 80 56.13z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default Icon5gConnectivity
